// Barra «falta configurar» (#1096) — aviso de «algo se dio de alta».
//
// Sin dependencias a propósito: lo importa el cliente HTTP (utils/api.ts), y el
// store de la barra importa al cliente, así que aquí no puede haber ciclo.

export const SETUP_CHANGED_EVENT = "setup:changed";

/** Escrituras que no destraban ninguna app (evita re-evaluar por nada). */
const IGNORED = [/^\/?setup\//, /^\/?tutorials\//, /^\/?ai\//, /^\/?auth\//, /^\/?logout/, /analytics/i];
const DEBOUNCE_MS = 1500;

let timer: ReturnType<typeof setTimeout> | null = null;

/**
 * Avisa ya que cambió algo que la barra evalúa (lo usa quien sabe que dio de
 * alta algo, p. ej. el copiloto al guardar).
 */
export function notifySetupChanged() {
  if (typeof window === "undefined") return;
  if (timer) clearTimeout(timer);
  timer = null;
  window.dispatchEvent(new Event(SETUP_CHANGED_EVENT));
}

/**
 * Lo llama el cliente HTTP tras cada escritura exitosa: agrupa las de un mismo
 * guardado (p. ej. dispositivo + vínculo) en un solo aviso.
 */
export function scheduleSetupChangedAfterWrite(method: string | undefined, url: string | undefined) {
  const m = String(method || "get").toLowerCase();
  if (m === "get" || m === "head" || m === "options") return;
  const path = String(url || "").replace(/^https?:\/\/[^/]+/, "");
  if (IGNORED.some((re) => re.test(path))) return;
  if (typeof window === "undefined") return;
  if (timer) clearTimeout(timer);
  timer = setTimeout(notifySetupChanged, DEBOUNCE_MS);
}
